import { makeStyles, lighten } from "@material-ui/core/styles";

import {
  blueGrey,
  deepPurple,
  indigo,
  lightBlue,
  cyan,
  teal,
  green,
  grey,
  red,
  orange,
} from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    height: "90px",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "& h6": {
      fontSize: 12,
      fontWeight: 400,
      textTransform: "capitalize",
    },
  },

  amount: {
    fontSize: 24,
    fontWeight: 400,
    fontFamily: "Montserrat, sans-serif",
    lineHeight: 1.1,
    marginTop: theme.spacing(0.5),
  },

  count: {
    fontSize: 15,
    fontWeight: 500,
    fontFamily: "Montserrat, sans-serif",
    lineHeight: 1.2,
    marginTop: theme.spacing(0.5),
  },

  nameDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    minWidth: 0,
    paddingRight: "10px",

    "& h6": {
      fontSize: 12,
      fontWeight: 400,
      textTransform: "capitalize",
      lineHeight: 1.3,
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
  },

  new: {
    color: blueGrey[500],
    backgroundColor: blueGrey[100],
  },

  booking: {
    color: deepPurple[500],
    backgroundColor: deepPurple[100],
  },

  quotation: {
    color: indigo[500],
    backgroundColor: indigo[100],
  },

  confirmed: {
    color: lightBlue[500],
    backgroundColor: lightBlue[100],
  },

  timesheetSubmitted: {
    color: cyan[500],
    backgroundColor: cyan[100],
  },

  approved: {
    color: teal[500],
    backgroundColor: teal[100],
  },

  paid: {
    color: green[500],
    backgroundColor: green[100],
  },

  quoteSupplied: {
    color: grey[500],
    backgroundColor: grey[100],
  },

  cancel: {
    color: red[500],
    backgroundColor: red[100],
  },

  warning: {
    color: orange[500],
    backgroundColor: orange[100],
  },

  currentDayBookings: {
    backgroundColor: lighten(theme.palette.success.light, 0.9),
  },

  upcomingBookings: {
    backgroundColor: lighten(theme.palette.info.light, 0.9),
  },
}));
